import { useEffect, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

export function AnimatedGridHelper({
  size,
  divisions,
  centerLineColor,
  gridColor,
  transitionSpeed = 6,
  ...rest
}) {
  const helperRef = useRef(null);
  const targetCenter = useRef(new THREE.Color(centerLineColor));
  const targetGrid = useRef(new THREE.Color(gridColor));

  useEffect(() => {
    targetCenter.current.set(centerLineColor);
    targetGrid.current.set(gridColor);
  }, [centerLineColor, gridColor]);

  useFrame((state, delta) => {
    const h = helperRef.current;
    if (!h) return;
    const mats = Array.isArray(h.material) ? h.material : [h.material];
    if (mats.length < 2 || !mats[0]?.color || !mats[1]?.color) return;
    const alpha = 1 - Math.exp(-transitionSpeed * delta);
    const prev0 = mats[0].color.clone();
    const prev1 = mats[1].color.clone();
    mats[0].color.lerp(targetCenter.current, alpha);
    mats[1].color.lerp(targetGrid.current, alpha);
    const moved =
      Math.abs(mats[0].color.r - prev0.r) +
      Math.abs(mats[0].color.g - prev0.g) +
      Math.abs(mats[0].color.b - prev0.b) +
      Math.abs(mats[1].color.r - prev1.r) +
      Math.abs(mats[1].color.g - prev1.g) +
      Math.abs(mats[1].color.b - prev1.b);
    if (moved > 0.0002) state.invalidate();
  });

  return (
    <gridHelper
      ref={helperRef}
      args={[size, divisions, centerLineColor, gridColor]}
      {...rest}
    />
  );
}
